import * as React from 'react';

import { RoleActionContext, RoleValueContext } from './context';
import { useRoleAction, useRoleValue } from './hook';
import { initialState } from './initial';
import { reducer } from './reducer';

const RoleFormContext = ({
  children,
  ...props
}: React.PropsWithChildren<typeof initialState>) => {
  const [state, dispatch] = React.useReducer(reducer, {
    ...initialState,
    ...props,
  });
  return (
    <RoleValueContext.Provider value={state}>
      <RoleActionContext.Provider value={dispatch}>
        {children}
      </RoleActionContext.Provider>
    </RoleValueContext.Provider>
  );
};

export { RoleFormContext, useRoleAction, useRoleValue };
